<template>
  <header>
    <router-link id="epicentric-logo" class="epicentric-logo" to="/"> 
      <img class="logo-desk is-desktop" alt="Epicentric logo" src="../assets/logo/logo_desk.svg">
      <img class="logo-mobile is-mobile" alt="Epicentric logo" src="../assets/logo/logo_mobile.svg">
    </router-link>
    <!-- CTA-->
    <div class="cta-wrap">
      <a class="cta-btn signup" href="https://play.epicentric.world/signup">
        Sign up
      </a>
      <a class="cta-btn login" href="https://play.epicentric.world/">
        Log in
      </a>
    </div>
    <!-- menu -->
    <button id="menu-btn" class="menu-btn" @click="toggleMenu()" v-bind:class="{'open': isMenuOpen}">
      <span class="close" v-if="!isMenuOpen"><img src="../assets/images/menu.svg" /><span>Menu</span></span>
      <span class="open" v-if="isMenuOpen"><img src="../assets/images/close.svg" /><span>Close</span></span>
    </button>

    <div id="menu-wrap-overlay" v-if="isMenuOpen" class="menu-wrap-overlay" @click="toggleMenu()"></div>

    <div id="menu-wrap" class="menu-wrap" v-bind:class="{'open': isMenuOpen}">
      <div class="lang-wrapper">
        <button @click="switchTo('en')">
          <img class="full-w" src="@/assets/images/en.jpg"/>
        </button>
        <button @click="switchTo('it')">
          <img class="full-w" src="@/assets/images/it.jpg  "/>
        </button>
      </div>

      <router-link class="menu-item mb-short" to="/">Home</router-link>


      <div class="menu-item-group green mb-short">
        <router-link class="menu-item" to="/digital-chaos">{{$t('DigitalChaosTitle1')}}</router-link>
        <router-link class="menu-item" to="/your-sacred-space">{{$t('SacredSpaceTitle1')}}</router-link>
        <router-link class="menu-item" to="/revolutionary-tool">{{$t('HomeSolutionTitle2')}}</router-link>
        <router-link class="menu-item" to="/ultimate-goal">{{$t('UltimateGoalTitle')}}</router-link>
      </div>
      
      <div class="menu-item-group orange mb-short">
        <!-- <div class="has-submenu">
          
          <div class="sub-menu menu-item-group orange">
            <router-link class="menu-item" to="/epicentric-and-music/why-to-own-music">{{$t('WhyOwnMusicTitle')}}</router-link>
            <router-link class="menu-item" to="/epicentric-and-music/music-lovers">{{$t('MusicLoversTitle')}}</router-link>
          </div>
        </div> -->
        <router-link class="menu-item" to="/epicentric-and-music">{{$t('MusicTitle')}}</router-link>
        <router-link class="menu-item" to="/epicentric-and-audio">{{$t('AudioTitle')}}</router-link>
        <router-link class="menu-item" to="/epicentric-and-visual">{{$t('VisualTitle')}}</router-link>
        <router-link class="menu-item" to="/maps-gallery">{{$t('GalleryTitle')}}</router-link>
      </div>
      
      <div class="menu-item-group grey mb-short">
        <router-link class="menu-item" to="/epicentric-vs">{{$t('EpicentricVsTitle')}}</router-link>
        <router-link class="menu-item" to="/manifesto">{{$t('ManifestoTitle')}}</router-link>
        <router-link class="menu-item" to="/about">{{$t('AboutTitle')}}</router-link>
        <router-link class="menu-item" to="/contact">{{$t('ContactTitle')}}</router-link>
      </div>

      <a class="menu-item" href="https://wiki.epicentric.world/" target="_blank">Epicentric Wiki</a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderNav',
  data () {
    return {
      isMenuOpen: false
    }
  },
  watch: {
    $route () {
      window.scrollTo(0,0);
      this.isMenuOpen = false
    }
  },
  methods: {
    switchTo (lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', this.$i18n.locale)
      this.isMenuOpen = false
    },
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
    } 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999999999;
  height: 60px;
  width: 100%;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $BG_W;
  border-bottom: 1px solid $GREY;
  .menu-btn {
    margin-right: 15px;
    padding: 5px 0px;
    background-color: transparent;
    border: 0px;
    cursor: pointer;
    img {
      width: 35px;
      border: 1px solid $ORANGE;
      padding: 5px 7px;
      margin-right: 10px;
    }
    span {
      font-size: .8rem;
      opacity: 1;
      color: $ORANGE;
    }
    .open {
      display: flex;
      justify-content: center;
      img {
        padding: 7px 7px;
        border: 1px solid #333333;
      }
      span{
        align-self: center;
      }
    }
    .close {
      justify-content: center;
      display: flex;
      span{
        align-self: center;
      }
    }
    &.open{
      &:hover {
        .open {
          text-decoration: underline;
          opacity: 1;
          color: #333333;
        }
        .close {
          text-decoration: underline;
          opacity: 1;
          color: $ORANGE;
        }
      }
    }
  }
  .menu-wrap-overlay {
    position: fixed;
    top: 60px;
    right: 0px;
    z-index: 14;
    height: 6000px;
    width: 100%;
    .open {
      display: block;
    }
  }
  .menu-wrap {
    position: fixed;
    top: 60px;
    right: 0px;
    // border: 1px solid $ORANGE;
    border-bottom: 0px;
    // background-color: rgb(237, 237, 237, .6);
    background-color: #F4F4F4;
    padding: 21px;
    display: none;
    transition: all .3s ease-in;
    z-index: 15;
    &.open {
      display: block;
    }

    .lang-wrapper{
      width: 100%;
      height: 25px;
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      button{
        border: 0px;
        background-color: transparent;
        cursor: pointer;
        height: 100%;
        margin-right: 14px;
        img{
          height: 100%;
        }
      }
    }

    .menu-item{
      background-color: #FFF;
      &.mb-short{
        margin-bottom: 14px;
      }
    }
    .menu-item-group{
      &.mb-short{
        margin-bottom: 14px;
      }
      &.green{
        border-left: 4px solid $GREEN;
        .menu-item{
          &:hover {
            color: #333333!important;
            background-color: $GREEN_TRANS;
          }
          &.router-link-active, &.router-link-exact-active{
            color: #333333!important;
            background-color: $GREEN_TRANS;
          }
        }
      }
      &.orange{
        border-left: 4px solid $ORANGE;
        .menu-item{
          &:hover {
            color: #333333!important;
            background-color: $ORANGE_TRANS;
          }
          &.router-link-active, &.router-link-exact-active{
            color: #333333!important;
            background-color: $ORANGE_TRANS;
          }
        }
      }
      &.grey{
        border-left: 4px solid $BG_B;
        .menu-item{
          &:hover {
            color: #333333!important;
            background-color: $BG_B_TRANS;
          }
          &.router-link-active, &.router-link-exact-active{
            color: #333333!important;
            background-color: $BG_B_TRANS;
          }
        }
      }
    }
    a {
      display: block;
      width: 100%;
      height: 35px;
      line-height: 35px;
      color: #333333;
      padding: 0 25px;
      padding-left: 15px;
      font-size: .8rem;
      transition: all .3s ease-in;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: bold;
      &:hover {
        color: $ORANGE;
      }
      &.router-link-active{
        color: $ORANGE;
      }
      &.active {
        background-color: $ORANGE;
        color: #FAFAFA;
        &:hover {
          color: #FAFAFA;
        }
      }
      &.download{
        display: none;
      }
    }
    .has-submenu{
      position: relative;
      &:hover{
        background-color: darken(#EDEDED, 5%);
        .sub-menu{
            display: block;
        }   
      }
      .sub-menu{
        position: absolute;
        top: 0px;
        right: calc(100% + 4px);
        display: none;
        background-color: #EDEDED;
        width: 180px;
      }       
    }
  }
  .epicentric-logo {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    height: 40px;
    opacity: 1;
    transition: all .4s ease-out;
    &.hide {
      opacity: 0;
    }
    img {
      height: 100%;
      &.logo-desk {
        display: block;
      }
      &.logo-mobile {
        display: none;
      }
    }
  }
  .cta-wrap{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 40px;
    .cta-btn {
      display: inline-block;
      width: 70px;
      padding: 10px 10px;
      text-align: center;
      font-family: 'titilliumWeb-Bold';
      text-decoration: none;
      font-size: .9rem;
      transition: all .3s ease-out;
      &.signup {
        margin-right: 30px;
        border: 1px solid $GREEN;
        background-color: $GREEN;
        color: $TEXT_W;
        &:hover {
          color: $GREEN;
          background-color: $BG_W;
        }
      }
      &.login {
        border: 1px solid $ORANGE;
        background-color: $ORANGE;
        color: $TEXT_W;
        &:hover {
          color: $ORANGE;
          background-color: $BG_W;
        }
      }
      &.download{
        width: 90px;
        border: 1px solid $DOWNLOAD;
        background-color: $DOWNLOAD;
        color: $TEXT_W;
        &:hover {
          color: $DOWNLOAD;
          background-color: $BG_W;
        }
      }
    } 
  }
}
 
@media (max-width: 1023px) {
  header {
    .cta-wrap{
      .cta-btn{
        &.signup{
          margin-right: 0px;
          padding-left: 10px 0px;
          background-color: $GREEN;
          .cta-signup {
            display: none;
          } 
        }
      } 
    }
  }
}

@media (max-width: 1024px) {
  header {
    .menu-wrap{
      a {
        height: 45px;
        line-height: 45px;
      }
      .has-submenu{
        .sub-menu{
          margin-left: 5px;
          display: block;
          border-left: 1px solid #EA8B21;
        }   
      }
    }
  }
}

@media (max-width: 760px) {
  header {
    .menu-wrap {
      width: 100%;
      a {
        &.download{
          display: inline-block;
        }
      }
    }
    .cta-wrap{
      .download{
        display: none;
      }
    }
  }
}

@media (max-width: 550px) {
  header {
    .cta-wrap{
      .cta-btn{
        &.login{
          display: none;
        }
      } 
    }
  }
}

@media (max-width: 374px) {
  header {
    .epicentric-logo{
      img{
        &.logo-desk {
          display: none;
        }
        &.logo-mobile {
          display: block;
        }
      }
    }
  }
}
</style>
